import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../data/BaseUrl";
import { login } from "../../redux/reducers/authSlice";

const OpenPagesList = ({ decryptedText }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isReceptionist = decryptedText?.account_type === "receptionist";
  const isClusterManager = decryptedText?.account_type === "cluster_manager";
  const isTrainer = decryptedText?.account_type === "trainer";
  const isAdmin = decryptedText?.account_type === "admin";

  const onClickListItem = (e, pageName) => {
    e.preventDefault();

    const state = { decryptedText, isCustom: true, shouldLogout: false };

    if (pageName === "go-to-dashboard") {
      const loginPayload = {
        ...decryptedText,
      };

      dispatch(login(loginPayload));

      const baseUrl =
        BASE_URL === "https://devapi.wtfup.me"
          ? "https://newdevsuite.wtfup.me"
          : BASE_URL === "https://api.wtfgyms.com"
          ? "https://dashboard.wtfgyms.com"
          : "https://newdashboard.wtfup.me";
      // const baseUrl = BASE_URL;

      const redirectUrl = isTrainer ? `${baseUrl}/pt-track` : `${baseUrl}/`;

      window.open(redirectUrl, "_blank");
    } else {
      localStorage.setItem("pageState", JSON.stringify(state));

      const url = `/open-access/all-pages/${pageName}`;

      window.open(url, "_blank");
    }
  };

  const receptionistPages = [
    // "lead-and-followup-management",
    // "membership-requests",
    // "one-day-membership",
    // "pending-partial-payments",
    // "renewal-expiring-unpaid-members",
    // "import-members",
    // "pt-trial-registration",
    // "deffered-payments",
    // "expense-management",
    // "gym-plans",
    // "all-leaves",
    "dashboard-docs",
    "go-to-dashboard",
  ];
  const trainerPages = [
    // "trainer-member-engagement",
    // "pt-prospects",
    // "pt-trial-registration",
    // "pending-partial-payments",
    // "deffered-payments",
    // "expense-management",
    // "all-leaves",
    "dashboard-docs",
    "go-to-dashboard",
  ];
  const adminPages = [
    // "expense-management",
    // "approve-leaves",
    "dashboard-docs",
    "go-to-dashboard",
  ];
  const commonPages = [
    // "expense-management",
    "dashboard-docs",
    "go-to-dashboard",
  ];
  const renderPage = isReceptionist
    ? receptionistPages
    : isTrainer
    ? trainerPages
    : isAdmin || isClusterManager
    ? adminPages
    : commonPages;

  const onClickBackBtn = (e) => {
    e.preventDefault();
    localStorage.removeItem("pageState");
    navigate("/open-access", { state: { shouldLogout: true } });
  };

  useEffect(() => {
    if (!decryptedText) {
      navigate("/open-access");
    }
  }, [decryptedText]);

  useEffect(() => {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      try {
        const response = await originalFetch(...args);

        if (response.status === 401) {
          console.log("Unauthorized: Logging out");
          localStorage.removeItem("pageState");
        }

        return response;
      } catch (error) {
        console.error("Fetch error:", error);
        throw error;
      }
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  return (
    <div className="listed-divs-container mb30">
      <div
        className="flex-between"
        style={{ height: "auto", columnGap: "1rem" }}
      >
        <h2 className="page-heading">All Accessible Pages </h2>
        <div className="flexEnd">
          <button
            type="button"
            className="btn-save black-btn"
            onClick={(e) => onClickBackBtn(e)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-left-short"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
              />
            </svg>
            Back
          </button>
        </div>
      </div>

      <div className="cards-container cards-grid-container open-page-cards grid-4">
        {renderPage?.map((key, index) => {
          return (
            <div
              className={`dashboard-card-container`}
              onClick={(e) => onClickListItem(e, key)}
              key={index}
            >
              <div className="card-top space-between">
                <div className="card-top-content card-tagline">
                  <span className="card-label">{key?.replace(/-/g, " ")}</span>
                </div>

                <div className="card-top-content svg-img">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-arrow-right"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                    />
                  </svg>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OpenPagesList;
